import { X } from "lucide-react"
import { HTMLAttributes } from "react"
import { TagColor } from "shared-ts/libs/tag"

import { classNames } from "../../../../lib/classNames"
import { Icon, IconSizes } from "../../../Icon"

const tagBackgroundColorClasses: Record<TagColor, string> = {
  [TagColor.Undefined]: "bg-transparent",
  [TagColor.Red]: "bg-v2-background-danger-tonal",
  [TagColor.Pink]: "bg-accent-pink",
  [TagColor.Purple]: "bg-v2-background-ai-tonal",
  [TagColor.Blue]: "bg-accent-blue",
  [TagColor.Cyan]: "bg-v2-background-information-tonal",
  [TagColor.Green]: "bg-v2-background-success-tonal",
  [TagColor.Yellow]: "bg-v2-background-alert-tonal",
  [TagColor.Gray]: "bg-accent-gray",
}

export interface TagProps extends HTMLAttributes<HTMLDivElement> {
  name?: string
  color: TagColor
  isColorSwatchTag?: boolean
  onDelete?: () => void
}

export function Tag({
  name,
  color,
  onDelete,
  className,
  isColorSwatchTag,
  ...otherProps
}: TagProps) {
  return (
    <div
      className={classNames(
        "flex items-center gap-x-1",
        "h-6.5 w-fit",
        "rounded-control px-2",
        tagBackgroundColorClasses[color],
        isColorSwatchTag && "rounded-mark h-4 w-4",
        className
      )}
      {...otherProps}
    >
      <span
        className={classNames(
          "text-body select-none whitespace-nowrap",
          "color-default opacity-90"
        )}
      >
        {name}
      </span>
      {onDelete && (
        <button
          type="button"
          aria-label={`Remove ${name}`}
          className="rounded-control group/remove -mx-1 flex size-6 items-center justify-center"
          onClick={(e) => {
            e.stopPropagation()
            onDelete()
          }}
        >
          <Icon
            icon={X}
            size={IconSizes.ExtraSmall}
            className="color-icon-bold opacity-50 group-focus-visible/remove:opacity-75 group-active/remove:opacity-75"
          />
        </button>
      )}
    </div>
  )
}
